var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.backgroundColor}},[_c('template',{slot:"links"},[_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard'
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.pages'),
          icon: 'tim-icons icon-image-02'
        }}},[_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.pricing'), path: '/pricing' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.rtl'), path: '/rtl' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.timeline'), path: '/timeline' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.login'), path: '/login' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.register'), path: '/register' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.lock'), path: '/lock' }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.userProfile'), path: '/user' }}})],1),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.components'),
          icon: 'tim-icons icon-molecule-40'
        }}},[_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.multiLevelCollapse') }}},[_c('sidebar-link',{attrs:{"link":{
              name: _vm.$t('sidebar.example'),
              isRoute: false,
              path: 'https://google.com',
              target: '_blank'
            }}})],1),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.buttons'), path: '/components/buttons' }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.gridSystem'),
            path: '/components/grid-system'
          }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.panels'), path: '/components/panels' }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.sweetAlert'),
            path: '/components/sweet-alert'
          }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.notifications'),
            path: '/components/notifications'
          }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.icons'), path: '/components/icons' }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.typography'),
            path: '/components/typography'
          }}})],1),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.forms'), icon: 'tim-icons icon-notes' }}},[_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.regularForms'), path: '/forms/regular' }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.extendedForms'),
            path: '/forms/extended'
          }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.validationForms'),
            path: '/forms/validation'
          }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.wizard'), path: '/forms/wizard' }}})],1),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.tables'),
          icon: 'tim-icons icon-puzzle-10'
        }}},[_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.regularTables'),
            path: '/table-list/regular'
          }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.extendedTables'),
            path: '/table-list/extended'
          }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.paginatedTables'),
            path: '/table-list/paginated'
          }}})],1),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.maps'), icon: 'tim-icons icon-pin' }}},[_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.googleMaps'), path: '/maps/google' }}}),_c('sidebar-link',{attrs:{"link":{
            name: _vm.$t('sidebar.fullScreenMaps'),
            path: '/maps/full-screen'
          }}}),_c('sidebar-link',{attrs:{"link":{ name: _vm.$t('sidebar.vectorMaps'), path: '/maps/vector-map' }}})],1),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.widgets'),
          icon: 'tim-icons icon-settings',
          path: '/widgets'
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.charts'),
          icon: 'tim-icons icon-chart-bar-32',
          path: '/charts'
        }}}),_c('sidebar-link',{attrs:{"link":{
          name: _vm.$t('sidebar.calendar'),
          icon: 'tim-icons icon-time-alarm',
          path: '/calendar'
        }}})],1)],2),_c('sidebar-share',{attrs:{"background-color":_vm.backgroundColor},on:{"update:backgroundColor":function($event){_vm.backgroundColor=$event},"update:background-color":function($event){_vm.backgroundColor=$event}}}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.backgroundColor}},[_c('top-navbar'),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_c('content-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }